import { render } from "./XHome.vue?vue&type=template&id=3085c3d8&scoped=true"
import script from "./XHome.vue?vue&type=script&lang=js"
export * from "./XHome.vue?vue&type=script&lang=js"

import "./XHome.vue?vue&type=style&index=0&id=3085c3d8&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3085c3d8"]])

export default __exports__